import {
    CAR_CERTIFICATE_FILENAME,
    CAR_PERSONAL_DETAILS,
    CAR_RACA_FILENAME,
    CAR_WOLF_RENEWAL_NCD_PROOF,
    Document,
    FREETEXT_DOCUMENT,
    Policy,
    PolicyHistory,
    WELCOME_PACK,
    WOLF_CANCELLATION_EMAIL_TITLE,
    WOLF_CHARGEBACK_CANCELLATION,
    WOLF_CHARGEBACK_COVER,
    WOLF_CHARGEBACK_NO_COVER,
    WOLF_MTA_CONFIRMATION_PACK,
    WOLF_RENEWAL_ACCEPTANCE,
    WOLF_RENEWAL_CLAIMS_IMPACT,
    WOLF_RENEWAL_INVITE_PACK,
    DIRECT_DEBIT_BILLING_NOTICE_OF_DEFAULT
} from "@falcon/services";
import {PluginTemplates} from "./PluginTemplates";
import * as moment from "moment";

export function mapDocumentTitles(documents: Document[], policy: Policy): Document[] { // NOSONAR
    return documents.map((document: Document) => { // NOSONAR

        const ext = document.name.substr(document.name.lastIndexOf('.') + 1);
        let docTitle = "";
        let docName = "";
        if (document.name.includes("policy_schedule_renters")) {
            docTitle = "Schedule of Renters Insurance";
            docName = "policy_schedule_renters";
            return {
                ...document,
                title: `${docTitle}, ${ext.toUpperCase()} ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle}`,
                name: `${docName}.${ext}`,
                date: policy.interaction.headerInfo.startDate
            };
        }
        const policyHistory: PolicyHistory = getVehicleInformation(document.tags, policy.policyHistoryList);

        let vehicle: any;
        if (policyHistory.vehicle) {
            vehicle = policyHistory.vehicle;
        } else {
            vehicle = policy.insuredVehicles[0];
        }

        if (document.name.includes("policy_certificate_final")) {
            docTitle = "Certificate of Motor Insurance";
            docName = "certificate_of_motor_insurance";
        } else if (document.name.includes("policy_schedule_car")) {
            docTitle = "Schedule of Motor Insurance";
            docName = "schedule_of_motor_insurance";
        } else if (document.name.includes("green_card")) {
            docTitle = "Green Card";
            docName = "Green Card";
            return {
                ...document,
                title: `${docTitle} (${vehicle.make} ${vehicle.registrationNumber}), ${moment(policy.startDate).format("DD MMMM YYYY")} ${ext.toUpperCase()} ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle} (${vehicle.make} ${vehicle.registrationNumber}), ${moment(policy.startDate).format("DD MMMM YYYY")} `,
                name: `${docName} (${policy.insuredVehicles[0].make}, ${vehicle.registrationNumber}), ${moment(policy.startDate).format("DD MMMM YYYY")}.${ext}`,
                date: policyHistory.startDate
            };
        } else if(document.name.includes(FREETEXT_DOCUMENT)) {
            docTitle = document.name.replace(FREETEXT_DOCUMENT, "");
            docName = document.name.replace(FREETEXT_DOCUMENT, "");
            return {
                ...document,
                title: `${docTitle} (${PluginTemplates.convertDateUTC(policyHistory.startDate, "DD MMMM YYYY")}), ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle} (${PluginTemplates.convertDateUTC(policyHistory.startDate, "DD MMMM YYYY")})`,
                name: `${docName}.${ext}`,
                date: policyHistory.startDate
            };
        } else if (document.name.includes(CAR_CERTIFICATE_FILENAME)) {
            docTitle = "Certificate of Insurance";
            docName = "certificate_of_insurance";
            return {
                ...document,
                title: `${docTitle} (${vehicle.registrationNumber}), ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle} (${vehicle.registrationNumber})`,
                name: `${docName}_${vehicle.registrationNumber}.${ext}`,
                date: policyHistory.startDate
            };
        } else if (document.name.includes(CAR_RACA_FILENAME)) {
            docTitle = "Running Account Credit Agreement (RACA)";
            docName = "wolf_credit_agreement";
            return {
                ...document,
                title: `${docTitle}, ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle}`,
                name: `${docName}.${ext}`,
                date: policyHistory.startDate
            };
        } else if(document.name.includes(CAR_PERSONAL_DETAILS)) {
            docTitle = "Personal Details";
            docName = "personal_details";
            return {
                ...document,
                title: `${docTitle}, ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle}`,
                name: `${docName}.${ext}`,
                date: policyHistory.startDate
            };
        } else if(document.name.includes(WELCOME_PACK)) {
            docTitle = "Policy Documents";
            docName = "new_sale_pack";
            return {
                ...document,
                title: `${docTitle} (${PluginTemplates.convertDateUTC(policyHistory.startDate, "DD MMMM YYYY")}), ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle} (${PluginTemplates.convertDateUTC(policyHistory.startDate, "DD MMMM YYYY")})`,
                name: `${docName}.${ext}`,
                date: policyHistory.startDate
            };
        } else if(document.name.includes(WOLF_MTA_CONFIRMATION_PACK)) {
            docTitle = "Updated policy documents";
            docName = "mta_confirmation_pack";
            return {
                ...document,
                title: `${docTitle} (${PluginTemplates.convertDateUTC(policyHistory.startDate, "DD MMMM YYYY")}), ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle} (${PluginTemplates.convertDateUTC(policyHistory.startDate, "DD MMMM YYYY")})`,
                name: `${docName}.${ext}`,
                date: policyHistory.startDate
            };
        } else if(document.name.includes(WOLF_CHARGEBACK_COVER)) {
            docTitle = "Notice of Cancellation";
            docName = "chargeback_cover";
            return {
                ...document,
                title: `${docTitle}, ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle}`,
                name: `${docName}.${ext}`
            };
        } else if(document.name.includes(WOLF_CHARGEBACK_NO_COVER)) {
            docTitle = "Notice of Arrears";
            docName = "chargeback_no_cover";
            return {
                ...document,
                title: `${docTitle}, ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle}`,
                name: `${docName}.${ext}`
            };
        } else if(document.name.includes(WOLF_CHARGEBACK_CANCELLATION)) {
            docTitle = "Policy cancellation";
            docName = "chargeback_cancellation";
            return {
                ...document,
                title: `${docTitle}, ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle}`,
                name: `${docName}.${ext}`
            };
        } else if (document.name.includes(WOLF_RENEWAL_INVITE_PACK)) {
            docTitle = "Renewal Invitation";
            docName = "renewal_invite_pack";
            return {
                ...document,
                title: `${docTitle}, ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle}`,
                name: `${docName}.${ext}`
            }
        } else if (document.name.includes(WOLF_RENEWAL_ACCEPTANCE)) {
            docTitle = "Policy Documents";
            docName = "wolf_renewal_acceptance";
            return {
                ...document,
                title: `${docTitle}, ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle}`,
                name: `${docName}.${ext}`
            }
        } else if (document.name.includes(WOLF_RENEWAL_CLAIMS_IMPACT)) {
            docTitle = "Updated Renewal Invitation";
            docName = "updated_renewal_invite_pack";
            return {
                ...document,
                title: `${docTitle}, ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle}`,
                name:  `${docName}.${ext}`
            }
        } else if (document.name.includes(CAR_WOLF_RENEWAL_NCD_PROOF)) {
            docTitle = "Renewal NCD proof";
            docName = "renewal_ncd_proof";
            return {
                ...document,
                title: `${docTitle}, ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle}`,
                name: `${docName}.${ext}`
            }
        } else if (document.name.includes(WOLF_CANCELLATION_EMAIL_TITLE)) {
            docTitle = "Cancellation Email";
            return {
                ...document,
                title: `${docTitle}, ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
                downloadName: `${docTitle}`,
                name: document.name
            }
        } else if (
            document.name.includes(DIRECT_DEBIT_BILLING_NOTICE_OF_DEFAULT)
        ) {
            docTitle = "Billing - Notice of default";
            docName = "direct_debit_billing_notice_of_default";

            return {
                ...document,
                title: `${docTitle}, ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
                downloadName: docTitle,
                name: `${docName}.${ext}`
            };
        }
        return {
            ...document,
            title: `${docTitle} (${vehicle.registrationNumber}), ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
            downloadName: `${docTitle} (${vehicle.registrationNumber})`,
            name: `${docName}_${vehicle.registrationNumber}.${ext}`,
            date: policyHistory.startDate
        };
    });
} // NOSONAR

export function mapCommunicationTitles(documents: Document[], policy: Policy): Document[] {
    return documents.map((document: Document) => {

        const ext = document.name.substr(document.name.lastIndexOf('.') + 1);
        let docTitle = "";
        let docName = "";
        const inceptionDate = moment.utc(policy.startDate, moment.ISO_8601).toDate();
        const mtcDate = moment.utc(policy.endDate, moment.ISO_8601).toDate();
        mtcDate.setDate(mtcDate.getDate() - 90);

       if (document.name.includes(WOLF_CANCELLATION_EMAIL_TITLE)) {
           if (policy.interaction.policyHolder.ncd.yearCount > 0 && inceptionDate < mtcDate) {
               docTitle = "Cancellation Email and Proof of NCD";
               docName = "cancellation_email_and_proof_of_ncd";
           } else {
               docTitle = "Cancellation Email";
               docName = "cancellation_email";
           }
        }
        return {
            ...document,
            title: `${docTitle}, ${ext.toUpperCase()}, ${formatFileSize(document.fileSize)}`,
            downloadName: `${docTitle}`,
            name: `${docName}.${ext}`,
        };
    });
}

function getVehicleInformation(documentTags: string[], policyHistory: PolicyHistory[]): PolicyHistory {
    let policyHistoryMatch: PolicyHistory = {} as PolicyHistory;
    const agreementVersionPrefix: string = "agreement_version_";

    policyHistory.forEach((ph: PolicyHistory) => {
        documentTags.forEach(tag => {
            if (tag.startsWith(agreementVersionPrefix)) {
                const agreementVersionNumber: string = tag.replace(agreementVersionPrefix, "");
                if (agreementVersionNumber === ph.number.toString()) {
                    policyHistoryMatch = ph;
                    return;
                }
            }
        })
    });

    return policyHistoryMatch;
}

function formatFileSize(byteSize: any) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (byteSize === 0) { return ''; }
    const kilobyteSize: number = parseInt(String(Math.floor(Math.log(byteSize) / Math.log(1024))), 10);
    return Math.round(byteSize / Math.pow(1024, kilobyteSize)) + ' ' + sizes[kilobyteSize];
}
